import { useCallback } from 'react';

import { hasNavigatorApi, hasWindow } from 'utils/browser.utils';

export const useMobileShare = () => {
  const writeToClipboard = useCallback((data: ShareData) => {
    if (!hasWindow()) return;
    if (hasNavigatorApi('share')) {
      return navigator.share(data);
    }
  }, []);

  return writeToClipboard;
};
